module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fnDyd"))).then(() => module.bundle.root('lKlEc'));